<template>
  <div class="qmkey-related-inline-table">
    <v-data-table
      :headers="workflowFields"
      :items="current_qunit['workflow']"
      item-key="transition_id"
      disable-pagination
      disable-filtering
      dense
      :items-per-page="1000"
      hide-default-footer
      show-expand
      class="qmkey-explorer-table-expansion-table table-contrast-expand-icon"
      disable-sort
    >
      <template v-slot:expanded-item="{ item }">
        <td
          :colspan="workflowFields.length + 1"
          class="qmkey-explorer-table-expansion-td"
        >
          <v-container>
            <v-row
              v-for="(field, index) in item.fields"
              :key="index"
              dense
              no-gutters
            >
              <v-col cols="10">
                <span class="data-inline-data-title"> {{ field.label }} </span>
                <div class="text-justify text-block data-inline-data"
                  v-html="field.extended_value"
                >
                  
                </div>
              </v-col>
            </v-row>
          </v-container>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  name: 'InlineBoxWorkflow',
  props: {
    current_qunit: Object,
    props: Object
  },
  data() {
    return {
      extended: [],
      value: true,
      workflowFields: [
        { value: 'transition', text: 'Transition Name' },
        { value: 'state_in', text: 'Initial State' },
        { value: 'state_out', text: 'End State' },
        { value: 'transition_time', text: 'Execution Time' },
        { value: 'transition_user', text: 'Executed By' },
        { value: 'destination_responsible', text: 'Responsible' },
        { value: 'destination_limit', text: 'Limit Time' },
        { value: 'data-table-expand', text: '', sortable: false },
      ],
    }
  },
  mounted: function () {
    this.all()
  },
  computed: {
    check_value() {
      return this.extended.length == this.current_qunit.inline_box_data.length
    },
  },
  methods: {
    // Create an array the length of our items
    // with all values as true
    all() {
      let extend = []
      for (var i = 0; i < this.current_qunit.inline_box_data.length; i++) {
        extend.push(i)
      }
      this.extended = extend
    },
    // Reset the panel
    none() {
      this.extended = []
    },
    toogle(newValue) {
      // if (newValue == true) {
      //   this.all()
      // }
      this.all()
    },
    changeCheckValue() {
      if (this.value == true) {
        this.value = false
      }
    },
    copyEmailCode() {
      let textToCopy = this.current_qunit.uid
      navigator.clipboard.writeText(textToCopy)
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/explorer.scss';
</style>
<style scoped>
.text-block {
    white-space: pre-line; 
}
</style>